"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getBrowserLocale = void 0;
function getBrowserLocale() {
    if (navigator.languages && navigator.languages.length) {
        return navigator.languages[0];
    }
    else {
        // @ts-ignore
        if (navigator.browserLanguage || navigator.systemLanguage || navigator.userLanguage) {
            // @ts-ignore
            return navigator.browserLanguage || navigator.systemLanguage || navigator.userLanguage;
        }
        else {
            return navigator.language;
        }
    }
}
exports.getBrowserLocale = getBrowserLocale;
